export default "/images/vendor/flag-icon-css/flags/4x3/bg.svg?c9c13073359faec8e076a738146b8f66";